import { ref } from 'vue';
import type { TooltipInstance } from './Tooltip.model';

const useTooltipService = () => {
	const tooltip = ref<TooltipInstance | null>(null);

	const open = (nextTooltip: TooltipInstance) => {
		tooltip.value = nextTooltip;
		return nextTooltip.id;
	};

	const update = (id: string, updates: Partial<TooltipInstance>) => {
		if (!tooltip.value || tooltip.value.id !== id) {
			return;
		}

		tooltip.value = {
			...tooltip.value,
			...updates,
		};
	};

	const close = (id?: string) => {
		if (!tooltip.value) {
			return;
		}

		if (id && tooltip.value.id !== id) {
			return;
		}

		tooltip.value = null;
	};

	return {
		tooltip,
		open,
		show: open,
		update,
		close,
		hide: close,
		clear: () => close(),
	};
};

export const tooltipService = useTooltipService();
export type TooltipService = ReturnType<typeof useTooltipService>;
